import { RootState } from 'store/rootSlices';

export const getEnrollmentsProofsSlice = (state: RootState) => state.EnrollmentsProofs;
export const getUserNmec = (state: RootState) => state.App.user.nmec;
export const getRegistration = (state: RootState) => state.StudentRegistrationDropdown.registration;
export const getUserRegistrations = (state: RootState) => state.App.user.registrations;
export const getUser = (state: RootState) => state.App.user;
export const getCurrentLocale = (state: RootState) => state.App.currentLocale;
